import {authTokenProvider} from "../AuthTokenProvider";
import {getTokenOptions} from "../config/getAccountSettingsToken";

const X_API_KEY = process.env.REACT_APP_X_API_KEY;

function addXApiKeyHeader(headers = {}) {
    headers["X-API-KEY"] = X_API_KEY;
    return headers;
}

async function attachAuth(headers, scope) {
    try {

        const token = await authTokenProvider.getToken(
            getTokenOptions(scope)
        );
        if (token) {
            headers["Authorization"] = `Bearer ${token}`;
        }
    } catch (e) {
        console.error("Token fetch failed", e);
    }
}

async function request(url, options = {}, scope, privateRoute= true) {
    let headers = options.headers || {};

    addXApiKeyHeader(headers);
    if(privateRoute) {
        await attachAuth(headers, scope);
    }
    const finalOptions = {
        ...options,
        headers
    };
    return fetch(url, finalOptions).then(handleResponse);
}

export const fetchWrapper = {
    get: (url, scope, privateRoute=true) =>
        request(url, { method: "GET" }, scope, privateRoute),

    post: (url, body, scope) =>
        request(
            url,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            },
            scope
        ),

    put: (url, body, scope) =>
        request(
            url,
            {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            },
            scope
        ),

    delete: (url, scope) =>
        request(
            url,
            { method: "DELETE", headers: { accept: "application/json" } },
            scope
        ),
};

export async function handleResponse(response) {
    try {
        return response.text().then((text) => {
            try {
                if (response.ok) {
                    if (text) {
                        return text && JSON.parse(text);
                    }
                    return { message: 'ok' };
                } else if (response.status === 422) {
                    const data = text && JSON.parse(text);
                    return { error: data.msg || data.message };
                } else if (response.status === 400) {
                    const data = text && JSON.parse(text);
                    return { error: data.error || data.message };
                } else if (response.status === 409) {
                    const data = text && JSON.parse(text);
                    return { error: data.message || data.msg || 'Conflict error' };
                } else if (response.status === 401) {
                    const data = text && JSON.parse(text);
                    return { error: data.error || data.message };
                } else if (!response.ok) {
                    const data = text && JSON.parse(text);
                    const error = (data && data.message) || response.statusText;
                    console.log(error);
                    return { error };
                }
            } catch (e) {
                return { error: e.message || 'Unknown error' };
            }
        });
    } catch (e) {
        return { error: e.message || 'Unknown error' };
    }
}

